var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-fit-wrap"},[_c('img',{staticClass:"image-fit",attrs:{"crossorigin":"anonymous","src":_vm.Img,"alt":"","srcset":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }